import {
  Avatar,
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Heading,
  HStack,
  SimpleGrid,
  Spacer,
  Text,
  useDisclosure,
  Input,
  Stack,
  Center,
  VStack,
  Divider,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { FcEngineering } from 'react-icons/fc';
import { useNavigate } from 'react-router-dom';
import {
  addDocumentFirebase,
  getCollectionFirebase,
} from '../../Api/firebaseApi';
import useUserStore from '../../Hooks/Zustand/Store';
import { auth, db } from '../../Config/firebase';
import BackButtons from '../../Components/Buttons/BackButtons';
import useKanbanStore from '../../Hooks/Zustand/kanbanStore';
import DynamicButton from '../../Components/Buttons/DynamicButton';
import CardAvatar from '../../Components/Card/CardAvatar';
import AlertArrayNull from '../../Components/AlertDialog/AlertArrayNull';
import {
  collection,
  getCountFromServer,
  query,
  where,
} from 'firebase/firestore';
import { MarkerType } from 'reactflow';
import { useTranslation } from 'react-i18next';

function KanbanOperationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const { resetTaskData, resetFilterData } = useKanbanStore((state) => state);
  const [dataKanban, setDataKanban] = useState([]);
  const [data, setData] = useState([]);
  const [title, setTitle] = useState('');
  const globalState = useUserStore();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editor, setEditor] = useState([]);
  const [filterOwner, setFilterOwner] = useState(false);

  const [modal, setModal] = useState({ delete: false, user: false });

  const itemsPerPage = 8;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getData = async () => {
    const startIndex = (currentPage - 1) * itemsPerPage;

    let conditions = [
      { field: 'type', operator: '==', value: 'operation' },
      {
        field: 'companyId',
        operator: '==',
        value: globalState.currentCompany,
      },
      {
        field: 'projectId',
        operator: '==',
        value: globalState.currentProject,
      },
      { field: 'users', operator: 'array-contains', value: globalState.uid },
    ];
    const sortBy = { field: 'lastUpdated', direction: 'desc' };
    const limitValue = startIndex + itemsPerPage;

    if (filterOwner === true) {
      conditions = [
        { field: 'type', operator: '==', value: 'operation' },
        {
          field: 'companyId',
          operator: '==',
          value: globalState.currentCompany,
        },
      ];
    }

    try {
      globalState?.setIsLoading(true);
      const res = await getCollectionFirebase(
        'operations',
        conditions,
        sortBy,
        limitValue
      );
      setDataKanban(res);

      const collectionRef = collection(db, 'operations');

      // Membuat kondisi filter tambahan untuk pemilik (owner) jika filterOwner aktif
      let countQuery = query(
        collectionRef,
        where('companyId', '==', globalState.currentCompany),
        where('projectId', '==', globalState.currentProject),
        where('type', '==', 'operation'),
        where('users', 'array-contains', globalState.uid)
      );
      if (filterOwner === true) {
        countQuery = query(
          collectionRef,
          where('companyId', '==', globalState.currentCompany),
          where('type', '==', 'operation')
        );
      }

      const snapshot = await getCountFromServer(countQuery);
      const assessmentLength = snapshot.data().count;

      setTotalPages(Math.ceil(assessmentLength / itemsPerPage));
    } catch (error) {
      toast({
        title: 'Deoapp.com',
        description: error.message,
        status: 'error',
        position: 'top-right',
        isClosable: true,
      });
    } finally {
      globalState?.setIsLoading(false);
    }
  };

  const handleOpenFilter = () => {
    if (globalState.roleCompany !== 'owner') {
      toast({
        title: t('toast.alert'),
        description: t('noAccess'),
        status: 'warning',
        duration: 9000,
        isClosable: true,
      });
      return;
    }

    setFilterOwner((prevFilterOwner) => !prevFilterOwner);
  };

  const handleLoadMore = () => {
    setCurrentPage((prev) => prev + 1);
  };

  useEffect(() => {
    getData();
  }, [globalState?.currentProject, filterOwner, currentPage]);

  const createNewKanban = () => {
    const initialNodes = [
      {
        id: '1',
        label: '1',
        position: { x: 0, y: 0 },
        data: { label: 'Add' },
        type: 'custom',
      },
      {
        id: '2',
        label: '2',
        position: { x: 0, y: 200 },
        data: { label: 'Add' },
        type: 'custom',
      },
    ];

    const initialEdges = [
      {
        id: '1-2',
        source: '1',
        target: '2',
        sourceHandle: 'c',
        targetHandle: 'a',
        type: 'floating',
        color: 'black',
        markerEnd: { type: MarkerType.ArrowClosed },
      },
    ];

    if (
      globalState?.currentCompany === null || globalState?.currentCompany === undefined ||
      globalState?.currentProject === null || globalState?.currentProject === undefined
    ) {
      toast({
        title: t('toast.alert'),
        description: 'You must setup your company and project.',
        status: 'warning',
        duration: 9000,
        isClosable: true,
      });
      return;
    }

    const data = {
      title: title,
      type: 'operation',
      default_score: 0,
      companyId: globalState?.currentCompany || globalState?.companies[0].id,
      projectId: globalState?.currentProject || globalState?.projects[0].id,
      lastUpdated: new Date(),
      nodes: initialNodes,
      edges: initialEdges,
      users: [globalState?.uid],
      usersDisplay: [
        {
          id: auth?.currentUser?.uid,
          image: auth.currentUser?.photoURL,
          name: auth?.currentUser?.displayName,
          email: auth?.currentUser?.email,
        },
      ],
    };
    addDocumentFirebase('operations', data, globalState.currentCompany).then(
      (x) => {
        navigate(`view/${x}/${title}`);
      }
    );
  };

  const handleNavigate = (x) => {
    navigate(`view/${x.id}/${x.title}`);
    resetTaskData();
    resetFilterData();
  };

  const modalTeam = (team) => {
    // setSelectedFlowchart(x)
    setData(team);

    const detail = team?.usersDisplay?.map((x) => {
      return {
        name: x.name,
        email: x.email,
        id: x.id,
      };
    });
    setEditor(detail);
    setModal({ ...modal, user: true });
  };

  return (
    <>
      <Stack spacing={8}>
        <HStack m="2" flexDirection={['column', 'column', 'row']}>
          <BackButtons />

          <Heading size={'md'}>{t('Operation')}</Heading>
          <Spacer />

          <DynamicButton
            title={t('seeAll')}
            action={'read'}
            onClick={handleOpenFilter}
            variant={'solid'}
          />

          <DynamicButton
            title={t('addOperation')}
            action={'create'}
            onClick={onOpen}
            variant={'solid'}
          />
        </HStack>
        {dataKanban?.length > 0 ? (
          <SimpleGrid columns={[1, 2, 4]} gap="3">
            {dataKanban?.map((x, i) => (
              <Stack key={i}>
                <CardAvatar
                  data={x}
                  title={x.title}
                  globalState={globalState}
                  onNavigate={() => handleNavigate(x)}
                  userArray={x?.usersDisplay}
                  timeCreated={x?.lastUpdated?.seconds}
                  modalTeam={() => modalTeam(x)}
                  owner={x?.users}
                  // onDelete={() => console.log(x)}
                  Icon={FcEngineering}
                />
              </Stack>
            ))}
          </SimpleGrid>
        ) : (
          <AlertArrayNull titleData={'Kanban'} action={t('addKanban')} />
        )}

        <Stack alignItems={'center'} justifyContent="center" py={5}>
          <Box>
            {currentPage < totalPages && (
              <Button
                colorScheme={'blue'}
                fontSize="sm"
                onClick={handleLoadMore}
              >
                {t('loadMore')}
              </Button>
            )}
          </Box>
        </Stack>
      </Stack>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('addKanban')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {/* <Lorem count={2} /> */}
            <Input type="text" onChange={(e) => setTitle(e.target.value)} />
          </ModalBody>

          <ModalFooter>
            <DynamicButton
              action={'create'}
              onClick={() => createNewKanban()}
              title={t('save')}
              variant={'solid'}
            />
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        onClose={() => setModal({ ...modal, user: false })}
        isOpen={modal?.user}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('team')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack>
              <Center>
                <VStack my={3}>
                  <Heading size={'md'}>{data?.title}</Heading>
                  <Divider />
                </VStack>
              </Center>
              <Stack maxH={'400px'} overflowY="scroll">
                {editor?.map((x, i) => (
                  <HStack key={i} justify={'space-between'} w={'full'} py={1}>
                    {x?.name === data?.usersDisplay[0]?.name ? (
                      <>
                        <HStack gap={3}>
                          <Avatar size={'md'} name={x?.name} />
                          <VStack align={'flex-start'}>
                            <Text fontWeight={'medium'} fontSize={'sm'}>
                              {x?.name}
                            </Text>
                            <Text fontSize={'xs'}>{x?.email}</Text>
                          </VStack>
                        </HStack>
                        <Stack>
                          <Box p={4}>
                            <Text fontStyle={'italic'} fontSize={'xs'}>
                              {t('creator')}
                            </Text>
                          </Box>
                        </Stack>
                      </>
                    ) : (
                      <>
                        <HStack gap={3}>
                          <Avatar size={'md'} name={x?.name} />
                          <Stack align={'flex-start'} spacing={0}>
                            <Text
                              fontWeight={500}
                              textTransform="capitalize"
                              fontSize={'sm'}
                            >
                              {x?.name}
                            </Text>
                            <Text fontSize={'xs'}>{x?.email}</Text>
                          </Stack>
                        </HStack>
                        <Stack>
                          {data?.users?.includes(globalState?.uid) && (
                            <Box p={4} w="15%">
                              <DynamicButton
                                action="delete"
                                size={'sm'}
                                // onClick={() => handleRemoveUser(x, data)}
                              />
                            </Box>
                          )}
                        </Stack>
                      </>
                    )}
                  </HStack>
                ))}
              </Stack>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setModal({ ...modal, user: false })}>
              {t('close')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default KanbanOperationPage;
